<template>
  <div class="todone-container">
    <h4>Add Task</h4>
    <b-textarea
      id="todo-text"
      v-model="todo"
      placeholder="what to do.."
      no-resize
    />
    <b-button
      :disabled="!todo"
      @click="addTodo"
      variant="outline-secondary add-btn"
      class="fa fa-plus"
    >
    </b-button>
    <div class="todo-list" v-for="(todo, index) in todos" :key="index">
      <p v-if="!todo.editing && !todo.completed">
        {{ todo.text }}
      </p>
      <p v-if="!todo.editing && todo.completed">
        <del>
          {{ todo.text }}
        </del>
      </p>
      <div v-if="!todo.editing">
        <span>
          <i
            class="fa fa-pencil edit-icon"
            title="Edit Todo"
            @click="editTodo(todo)"
          ></i>
        </span>
        <span v-if="!todo.completed">
          <i
            class="fa fa-remove"
            title="Complete Todo"
            @click="toggleTodo(todo)"
          ></i>
        </span>
        <span v-else>
          <i
            class="fa fa-plus"
            title="remove Todo"
            @click="toggleTodo(todo)"
          ></i>
        </span>
      </div>
      <b-form-input v-if="todo.editing" v-model="editingTodo"> </b-form-input>
      <span v-if="todo.editing">
        <i class="fa fa-check" title="Edit Todo" @click="handleEdit(todo)"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "todone",
  data() {
    return {
      todo: "",
      todos: [],
      editingTodo: "",
      oldText: ""
    };
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default: () => {}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {}
    },
    user: {
      type: Object,
      required: false,
      default: () => {}
    },
    typeaheadApps: {
      type: Array,
      default: () => ["Maps", "Calculator"]
    },
    idprop: {
      type: String
    },
    showTracking: {
      type: Boolean
    }
  },
  methods: {
    addTodo() {
      let todo = {
        text: this.todo,
        editing: false,
        completed: false
      };
      this.todos.push(todo);
      this.todo = "";
    },
    editTodo(todo) {
      todo.editing = true;
      this.editingTodo = todo.text;
      this.oldText = todo.text;
    },
    handleEdit() {
      this.todos.forEach(todo => {
        if (todo.text == this.oldText) {
          todo.text = this.editingTodo;
          todo.editing = false;
        }
      });
      //   this.editing = false;
      this.editingTodo = "";
      this.oldText = "";
    },
    toggleTodo(todo) {
      todo.completed = !todo.completed;
      console.log(this.todos);
    }
  }
};
</script>

<style lang="scss" scoped>
.todone-container {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  .add-btn {
    margin-top: 6px;
  }
  .edit-icon {
    margin-right: 6px;
  }
  .todo-list {
    margin-top: 6px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
